
import Vue from "vue";
import uiService from "./services/uiService";
import msDataProvider from "./services/msDataProvider";
import surveyService from "./services/surveyService";
import languages from "./constant/language"
import merge from "deepmerge";
import HelpCenter from "@/views/common/HelpCenter.vue";
import {required} from "@/plugins/validates";
import {StoreServiceInstance} from "@/services/storeService";
import ratingService from "@/services/ratingService";
import moment from "moment";
import errorService from "@/services/errorService";

export default Vue.extend({
  components: {HelpCenter},
  data() {
    return {
      helpCenter: false,
      titleSurvey: '',
      subTitleSurvey: '',
      languages,
      itemsLanguage: [],
      showDetail: false,
      alertShown: false,
      alertOpts: {},
      confirmShown: false,
      confirmOtps: {},
      backendServerNameShown: false,
      backendServerName: "",
      backendServerNameSaving: false,
      settingShown: false,
      settingSaving: false,
      dialogSurvey: false,
      countActiveApp: 0,
      countSkipSurvey: 0,
      binding: {},
      settings: {},
      settingsModalOptions: {
        title: "LAYOUT.SETTING",
        cancel: "APP.CANCEL",
        ok: "APP.SAVE",
        loading: false,
        translate: true,
        class: "setting-modal"
      },
      rating: 0,
      ratingDialog: false,
      backendServerNameOptions: {},
      language: null,
      ssl_insecure_skip_verify: null,
      use_bypass_channel: null,
      required,
      updateModal: false,
      updateModalOpts: {},
      updateStatus: {},
      expiredTokenModalOpts: {},
      expiredTokenModal: false,
      expiredTokenModalInterval: 0,
      tokenExp: 0
    };
  },
  watch: {
    "$route": {
      async handler(to, from) {
        const params = await surveyService.watchRoute(from, to)
        if (params) {
          await this.setUserData(params)
          const newData = await msDataProvider.getData("userData")
          await this.getUserData(newData)
        }
      },
      deep: true
    },
  },
  methods: {
    alertClose() {
      this.alertShown = false;
    },
    confirmNo() {
      this.confirmShown = false;
      this.showDetail = false;
      this.backendServerNameSaving = false;
      this.confirmOtps.callback && this.confirmOtps.callback(false);
    },
    confirmYes() {
      this.confirmShown = false;
      this.showDetail = false;
      this.backendServerNameSaving = false;
      this.confirmOtps.callback && this.confirmOtps.callback(true);
    },
    async changeBackendServerName() {
      if (!this.backendServerName || this.backendServerNameSaving) {
        return;
      }
      if (!this.$route.fullPath.includes('select_server_name')) {
        await msDataProvider.executeCommand("sdpStopAppAll", {});
      }
      this.backendServerNameSaving = true;
      this.backendServerNameOptions.loading = true;
      try {
        await msDataProvider.executeCommand(
            "backendServerNamePing",
            this.backendServerName
        );
      } catch (e) {
        this.backendServerNameOptions = {
          ...this.backendServerNameOptions,
          loading: false
        }
        this.backendServerNameSaving = false;
        if (e?.message) {
          this.backendServerNameOptions = {
            ...this.backendServerNameOptions,
            errorMessage: e.message.includes("Internet Connection Problem") ? this.$t('ERROR_SERVICE.ERROR_SERVICE_HOST_NAME') : this.$t('LOGIN.ERROR_SERVER')
          }
        }
        return;
      }
      await msDataProvider.executeCommand(
          "backendServerNameSetCurrentValue",
          this.backendServerName
      );
      this.backendServerNameOptions.loading = false;
      this.backendServerName = "";
      this.backendServerNameShown = false;
      this.backendServerNameSaving = false;
      location.reload();
    },
    async updateSetting() {
      if (this.settingSaving) {
        return;
      }
      for (const lang of this.languages) {
        if (lang.name === this.language) {
          this.language = lang.key
        }
      }
      this.binding.setting = {
        ...this.binding.setting,
        language: this.language,
        ssl_insecure_skip_verify: this.ssl_insecure_skip_verify,
        use_bypass_channel: this.use_bypass_channel
      }
      this.settingSaving = true;
      await StoreServiceInstance.setData(null, this.binding.setting);
      this.settingShown = false;
      this.settingSaving = false;
      location.reload()
    },
    async updateVersion() {
      sessionStorage.setItem('isOpenUpdateModal', 'true')
      await uiService.executeCommand("try", {
        async func() {
          this.updateModal = false;
          await msDataProvider.executeCommand("updateDownloadAndApply", {});
        },
        self: this,
      });
    },
    cancelUpdateVersion() {
      sessionStorage.setItem('isOpenUpdateModal', 'true')
    },
    registerCommands() {
      uiService.registerCommand(
          "try",
          async (opts: any = {}) => {
            try {
              const AsyncFunction = (async () => {
              }).constructor;
              if (opts.func instanceof AsyncFunction) {
                if (opts.self) {
                  await opts.func.call(opts.self);
                } else {
                  await opts.func();
                }
              } else {
                if (opts.self) {
                  opts.func.call(opts.self);
                } else {
                  opts.func();
                }
              }
            } catch (e) {
              let message = "";
              if (e.message.includes('UpdateDownloadAndApply')) {
                message = this.$t('ERROR_SERVICE.ERROR_UPDATE');
              } else {
                message = errorService.normalize(e.message).err
              }
              this.alertOpts = {
                title: this.$t('APP.WARNING'),
                message: message,
                details: e,
                cancel: this.$t('APP.CLOSE'),
              };
              this.alertShown = true;
            } finally {
              opts.callback && opts.callback();
            }
          },
          "callback"
      );
      uiService.registerCommand(
          "confirmShow",
          (opts: any = {}) => {
            if (!opts.message) {
              opts.message = "Are you sure to continue? It cannot be undone!";
            }
            this.confirmOtps = opts;
            this.confirmShown = true;
          },
          "callback"
      );
      uiService.registerCommand("alertShow", (opts: any = {}) => {
        if (!opts.title) {
          opts.title = this.$t('APP.WARNING');
        }
        this.alertOpts = opts;
        this.alertShown = true;
      });
      uiService.registerCommand("ratingDialogShow", () => {
        this.rating = 0;
        this.ratingDialog = true;
      });
      uiService.registerCommand("backendServerNameShow", () => {
        this.backendServerNameShown = true;
        this.backendServerNameOptions = {
          title: this.$t('APP.CHANGE_SERVER'),
          ok: this.$t('APP.SAVE'),
          cancel: this.$t('APP.CANCEL'),
          loading: false
        };
      });
      uiService.registerCommand("helpCenterShow", () => {
        this.helpCenter = true;
      });
      uiService.registerCommand("settingShow", () => {
        this.language = this.binding.setting.language;
        this.ssl_insecure_skip_verify = this.binding.setting.ssl_insecure_skip_verify;
        this.use_bypass_channel = this.binding.setting.use_bypass_channel;
        this.settingShown = true;
      });
      uiService.registerCommand("expiredModalShow", () => {
        let time = 3;
        this.expiredTokenModalOpts = {
          title: this.$t('APP.NOTIFICATION'),
          cancel: this.$t('LAYOUT.BACK_TO_LOGIN_PAGE_AFTER', {second: time}),
          content: this.$t('LAYOUT.EXPIRED_TOKEN_CONTENT'),
          closeable: false
        };
        this.expiredTokenModalInterval = setInterval(() => {
          this.expiredTokenModalOpts = {
            title: this.$t('APP.NOTIFICATION'),
            cancel: this.$t('LAYOUT.BACK_TO_LOGIN_PAGE_AFTER', {second: time}),
            content: this.$t('LAYOUT.EXPIRED_TOKEN_CONTENT'),
            closeable: false
          };
          if (time === 0) {
            this.expiredTokenModal = false;
            this.backToLogin();
          } else if (time < 0) {
            clearInterval(this.expiredTokenModalInterval);
          }
          time -= 1;
        }, 1000)
        this.expiredTokenModal = true;
      });
    },
    async updateDownloadAndApply() {
      await uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("updateDownloadAndApply");
        },
        self: this,
      });
    },
    async goToFeedback() {
      const res = await msDataProvider.getData("clientSetting")
      const userData = await msDataProvider.getData("userData")
      let url = ''
      let key: string = ''
      if (res && res.settings) {
        this.settings = res.settings
      }
      if (this.settings && this.settings.survey) {
        if (this.settings.survey.link) {
          key = this.settings.survey.link
        }
      }
      let params = {
        data: {
          [key]: {
            'countActiveApp': this.countActiveApp + 1,
          }
        }
      }
      const defaultUrl = 'https://localhost:40001/ui/user-guide/index'
      if (this.settings && this.settings.survey && this.settings.survey.link) {
        url = this.settings.survey.link
      }
      try {
        await msDataProvider.executeCommand(
            "extOpenUrl",
            {url: url || defaultUrl}
        );
        this.dialogSurvey = false
        params = merge(userData, params)
        await this.setUserData(params)
      } catch (e) {
        console.log(e);
      }
    },
    async handleCloseRatingModal() {
      this.ratingDialog = false;
      if (!this.rating) {
        return;
      }
      try {
        await msDataProvider.executeCommand('ratingCreate', {
          data: {
            rating: this.rating
          }
        })
        await ratingService.updateRating(this.rating);
      } catch (e) {
        console.log(e);
      }
    },
    async getUserData(userData) {
      const settings = await surveyService.setSettings()
      if (settings.title) {
        this.titleSurvey = settings.title
      }
      if (settings.subTitle) {
        this.subTitleSurvey = settings.subTitle
      }
      if (userData && userData.data &&
          userData.data[settings.key] &&
          userData.data[settings.key].countActiveApp) {

        this.countActiveApp = userData.data[settings.key].countActiveApp
        this.countSkipSurvey = userData.data[settings.key].countSkipSurvey

        if (userData.data[settings.key].countActiveApp === settings.afterOpen &&
            userData.data[settings.key].countSkipSurvey <= settings.maxIgnore &&
            this.$route.path !== '/user-guide/index') {
          this.dialogSurvey = true
        }

        if (userData.data[settings.key].countActiveApp === settings.afterOpen &&
            userData.data[settings.key].countSkipSurvey <= settings.maxIgnore &&
            this.$route.path !== '/user-guide/index') {
          this.dialogSurvey = true
        }
      }
    },
    async setUserData(userData) {
      try {
        await msDataProvider.executeCommand("userDataSet", userData);
      } catch (e) {
        console.log(e)
      }
    },
    async closeDialogFeedback() {
      this.dialogSurvey = false
      const res = await msDataProvider.getData("clientSetting")
      const userData = await msDataProvider.getData("userData")
      let key: string = ''
      if (res && res.settings) {
        this.settings = res.settings
      }
      if (this.settings && this.settings.survey) {
        if (this.settings.survey.link) {
          key = this.settings.survey.link
        }
      }
      let params = {
        data: {
          [key]: {
            'countSkipSurvey': this.countSkipSurvey + 1,
          }
        }
      }
      params = merge(userData, params)
      await this.setUserData(params)
    },
    backToLogin() {
      clearInterval(this.expiredTokenModalInterval)
      this.$router.push('/prepare');
    }
  },
  async created() {
    this.itemsLanguage = this.languages;
    const userData = await msDataProvider.getData("userData")
    await this.getUserData(userData)
    this.registerCommands();
    await msDataProvider.bindDataMany(
        [
          "backendServerNameCurrentValue",
          "backendServerNameDefaultValue",
          "setting",
          "updateAvailableVersionsInfo",
          "authenAuthenInfo"
        ],
        this.binding,
        this,
        (key, value) => {
          if (key === 'setting') {
            this.settingsModalOptions.defaultValue = {...value};
            moment.locale(value.language);
          }
          if (key === 'updateAvailableVersionsInfo') {
            if (value && value.update_versions && value.update_versions.length) {
              this.updateModalOpts = {
                title: 'APP.UPDATE_APP',
                ok: 'APP.UPDATE',
                cancel: 'APP.CANCEL',
                loading: false,
                width: 480,
                translate: true
              };
              if (!sessionStorage.getItem('isOpenUpdateModal')) {
                setTimeout(() => {
                  this.updateModal = true;
                }, 3000)
              }
            }
          }
          if (key === 'authenAuthenInfo' && value && value.token_info && value.token_info.exp) {
            this.tokenExp = value.token_info.exp;
          }
        },
        this
    );
    msDataProvider.watchData(
        "authenLoggedOut",
        (value) => {
          if (value && value.process_local_only) {
            setTimeout(() => {
              if(this.$route.path.includes('main')) {
                uiService.executeCommand('expiredModalShow');
              }
            }, 2000)
          } else if(value) {
            this.$router.push('/prepare').catch(e => e)
          }
        },
        this,
        true
    );
  }
});
